import React from 'react';
import './Footer.css';
import { MdArrowUpward } from 'react-icons/md';

import logo from '../../assets/Logo.png';
import Accordion from '../Accordion/Accordion';

const about = [
  {
    link: 'The Team',
  },
  {
    link: 'Career',
  },
];
const download = [
  {
    link: 'iOS',
  },
  {
    link: 'Android',
  },
];

const legal = [
  {
    link: 'Privacy Policy',
  },
  {
    link: 'Terms & Condition',
  },
];

const contact = [
  {
    link: 'FAQs',
  },
  {
    link: 'Support',
  },
];

const Footer = () => {
  return (
    <footer className="block footer">
      <div className="container grid footer__sections">
        <section className="footer__logo">
          <img src={logo} alt="Brand Logo" />
        </section>
        <Accordion data={about} title="About" />
        <Accordion data={download} title="Download" />
        <Accordion data={legal} title="Legal" />
        <Accordion data={contact} title="Contact" />
        <section className="icon footer__icon">
          <MdArrowUpward size={20} />
        </section>
      </div>
      <div className="footer__copyright">
        <p>© 2021 ALL RIGHTS RESERVED – HAELO</p>
      </div>
    </footer>
  );
};

export default Footer;
